import styled from 'styled-components'

export const StyledWrapper = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`

export const StyledInnerWrapper = styled.div`
    max-width: 600px;
    margin: 1.75rem auto;
    position: relative;
    width: auto;
    max-height: 100vh;
    overflow-y: auto;
`

export const StyledModal = styled.div`
    position: relative;
    background-color: #fff;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.5;
    padding: 24px;
    text-align: center;
    width: 100%;
    
    .modal-action {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 30px;

        button + button {
            margin-left: 20px;
        }
    }
    
    .modal-title {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .modal-table {
        margin-left:auto; 
        margin-right:auto;
        text-align: left;
    }

    .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
`

export const StyledCancelButton = styled.button`
    align-items: center;
    appearance: none;
    background-color: transparent;
    border: 0;
    color: ${props => props.theme.main.colors.secondaryColor};
    display: flex;
    font-size: 15px;
    justify-content: center;
    
    :hover {
        text-decoration: underline;
    }
    
    svg {
        height: 11px;
        margin-right: 6px;
        width: 11px;
        
        path {
            fill: ${props => props.theme.main.colors.secondaryColor};
        }
    }
`
